// Mobile dashboard with big touch-friendly buttons
// Grid of 4 main actions: New Survey, All Surveys, Categories, Settings
// Note: This renders inside the main Layout, not MobileLayout

import React from 'react'
import { useNavigate } from 'react-router-dom'
import { PlusCircle, ClipboardList, FolderOpen, Settings } from 'lucide-react'
import useSurveyStore from '../../stores/surveyStore'

const menuItems = [
  {
    path: '/survey/new',
    label: 'New Survey',
    description: 'Start a new property survey',
    icon: PlusCircle,
    color: 'bg-primary-600 hover:bg-primary-700',
    iconBg: 'bg-primary-500'
  },
  {
    path: '/surveys',
    label: 'All Surveys',
    description: 'View and manage surveys',
    icon: ClipboardList,
    color: 'bg-emerald-600 hover:bg-emerald-700',
    iconBg: 'bg-emerald-500'
  },
  {
    path: '/admin',
    label: 'Categories',
    description: 'Manage survey categories',
    icon: FolderOpen,
    color: 'bg-amber-600 hover:bg-amber-700',
    iconBg: 'bg-amber-500'
  },
  {
    path: '/settings',
    label: 'Settings',
    description: 'App preferences',
    icon: Settings,
    color: 'bg-slate-600 hover:bg-slate-700',
    iconBg: 'bg-slate-500'
  }
]

export default function MobileDashboard() {
  const navigate = useNavigate()
  const pendingUploads = useSurveyStore(state => state.pendingUploads)

  return (
    <div className="flex flex-col h-full -m-4 p-4">
      {/* Logo and welcome */}
      <div className="text-center mb-4 pt-2">
        <img
          src="https://cdn.prod.website-files.com/692966ae0a71b2cba119f627/6929802260ae20ce6dfade6f_card-logo.avif"
          alt="Clystcore Surveyors"
          className="h-14 w-auto mx-auto mb-3"
        />
        <h1 className="text-lg font-bold text-slate-900">Property Survey App</h1>
        {pendingUploads > 0 && (
          <p className="text-sm text-amber-600 mt-1">
            {pendingUploads} photo{pendingUploads !== 1 ? 's' : ''} pending sync
          </p>
        )}
      </div>

      {/* Big button grid - fills remaining space */}
      <div className="flex-1 grid grid-cols-2 gap-3 min-h-0">
        {menuItems.map((item) => {
          const Icon = item.icon
          return (
            <button
              key={item.path}
              onClick={() => navigate(item.path)}
              className={`${item.color} text-white rounded-2xl p-3 flex flex-col items-center justify-center gap-2 shadow-lg active:scale-95 transition-all duration-150 min-h-[140px]`}
            >
              <div className={`${item.iconBg} p-3 rounded-full`}>
                <Icon className="w-8 h-8" />
              </div>
              <div className="text-center">
                <div className="font-bold text-base">{item.label}</div>
                <div className="text-xs opacity-80 mt-0.5 leading-tight">{item.description}</div>
              </div>
            </button>
          )
        })}
      </div>
    </div>
  )
}
